<template>
  <v-footer color="secondary" height="80" dark padless class="fixed-footer">
    <v-row justify="center" no-gutters>
      <v-col class="primary py-4 text-center white--text" cols="12">
        <div>
          <span><v-icon color="green">mdi-phone</v-icon>电话：021-50917571</span>
          <span><v-icon color="green">mdi-wechat</v-icon>微信：13564896570</span>
          <span><v-icon color="green">mdi-email</v-icon>邮箱：info@pxfcc.com</span>
        </div>
        <div style="color: gray;">
          <span>{{ $t('copyright', { year: new Date().getFullYear() }) }}</span>
          <span><a href="https://beian.miit.gov.cn/" target="_blank"
              rel="noopener noreferrer">沪ICP备2024105987号-1</a></span>
        </div>
      </v-col>
    </v-row>
  </v-footer>
</template>

<script setup>

</script>

<style scoped>
/* 可以在这里添加自定义样式 */
.fixed-footer {
  position: fixed;
  bottom: 0;
  width: 100%;
  height: 100px;
  z-index: 1000;
}

.primary>div {
  margin: 3px;
}

.primary>div>span {
  margin-left: 20px;
}

.v-icon {
  size: x-small;
  margin-left: 5px;
}

.v-footer a {
  color: inherit;
  text-decoration: none;
}
</style>